import Config from '../libs/config.json'
import { isStorePage, isShamePage } from './is'

type ShuntTuple = [() => boolean, string]
type Language = 'en' | 'de' | 'fr' | 'tr' | 'zh-CN'

const { gameCode, activityCode, PLATFORM, LANGUAGE } = Config
const shuntTuple: ShuntTuple[] = [
    [() => isShamePage, 'abt-shame'],
    [() => isStorePage, 'store-version'],
]

export function getPageClasses() {
    return shuntTuple.reduce(
        (classes, [condition, cls]) =>
            condition() ? `${classes} ${cls}` : classes,
        ''
    )
}

export function getApiBasicParams() {
    return {
        gameCode,
        activityCode,
        platform: PLATFORM,
        language: getPageLanguage(),
    }
}

export function getPageLanguage() {
    return (document.documentElement.lang || LANGUAGE) as Language
}

export const clamp = (num: number, min: number, max: number) =>
    Math.min(max, Math.max(min, num))

export function getHtmlFileNameWithoutExt() {
    const pathname = location.pathname
    const fileName = pathname.substring(pathname.lastIndexOf('/') + 1)
    return fileName.replace(/\.html$/, '')
}
